module.exports = __webpack_public_path__ + "static/media/close-pink.e7278b46.svg";